import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPDFApply } from '../../eDocumentsSlice';

const NtsResult_01 = () => {
  const dispatch = useDispatch();
  const { ntsResult } = useSelector(state => state.eDocuments);

  useEffect(() => {
    dispatch(getPDFApply({ htmPCd: '1' }));
  }, []);

  return (
    <div className="yearendManualContentsBox">
      <div className={'ntsResultBox'}>
        <p className={'body2Bold subPoint3 ntsResultTitle'}>인원별 합계</p>
        <Table01 ntsResult={ntsResult} />
      </div>
      <div className={'ntsResultBox'}>
        <p className={'body2Bold subPoint3 ntsResultTitle'}>보험료 입력 상세 내역</p>
        <Table02 ntsResult={ntsResult} />
      </div>
    </div>
  );
};

export default NtsResult_01;

const Table01 = ({ ntsResult }) => {
  const headList = [
    // { name: "순번", key: "", width: "70px" },
    { name: '성명', key: 'htmPerNm', width: '30%' },
    { name: '주민등록번호', key: 'htmRegNum', width: '40%' },
    { name: '합계', key: 'sum', width: '30%', align: 'right' },
  ];

  return (
    <div>
      <div className="displayFlex tableTr">
        {headList.map((item, index) => (
          <div
            className="tableTitle captionBold"
            key={index}
            style={{ borderTop: '1px solid #D9D9D9' }}>
            {item.name}
          </div>
        ))}
      </div>
      {ntsResult?.listPerSum?.map((item, index) => (
        <div key={index} className="displayFlex tableTr">
          {headList.map((header, _index) => (
            <div
              className="tableBody captionMedium"
              key={_index}
              style={{ justifyContent: header.align }}>
              {item[header.key]}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

const Table02 = ({ ntsResult }) => {
  const headListGroup1 = [
    { name: '계약자', key: 'htmPerNm', width: '17%' },
    { name: '계약자 주민번호', key: 'htmRegNum', width: '25%' },
    { name: '월', key: 'htmMm2', width: '22%' },
    { name: '상호', key: 'htm004', width: '35%', d_width: '57%' },
  ];

  const headListGroup2 = [
    { name: '주피보험자	', key: 'htm011', width: '17%' },
    { name: '주피보험자 주민번호', key: 'htm010', width: '25%' },
    { name: '보험종류', key: 'htm002', width: '22%' },
    { name: '납입금액', key: 'htm001', width: '35%', align: 'right' },
  ];

  const headList = [headListGroup1, headListGroup2];

  return (
    <div className="tableWrapper">
      <div>
        {headList.map((headers, _index) => (
          <div className="displayFlex tableTr" key={_index}>
            {headers.map((item, index) => (
              <div
                className="tableTitle captionBold"
                key={index}
                style={{
                  width: item.width,
                  flex: 'none',
                  borderTop: _index == headList.length - 1 && 'none',
                }}>
                {item.name}
              </div>
            ))}
          </div>
        ))}
      </div>

      {/* 데이터 행 */}
      {ntsResult?.list?.map((item, index) => (
        <React.Fragment key={index}>
          {headList.map((headers, headerIndex) => (
            <div className="displayFlex tableTr" key={headerIndex}>
              {headers.map((header, _index) => (
                <div
                  className="tableBody captionMedium"
                  key={_index}
                  style={{
                    width: header.width,
                    flex: 'none',
                    justifyContent: header.align,
                  }}>
                  {item[header.key]}
                </div>
              ))}
            </div>
          ))}
        </React.Fragment>
      ))}
    </div>
  );
};
